<div>
    <div>
        <div class="expansion-filter" (click)="filtroUsuarioExpandido = !filtroUsuarioExpandido"
            *ngIf="(listaUsuarios?.ativos && listaUsuarios?.ativos.length) || (listaUsuarios?.inativos && listaUsuarios?.inativos.length)">
            <span class="subtitle-medium">
                Usuários
            </span>
            <mat-icon mat-list-icon [svgIcon]="'menu-up'" [@animationRotate]="filtroUsuarioExpandido ? 'open' : 'close'"
                class="icon-expansion"></mat-icon>
        </div>
        <div class="container-filter" [@animationShowHide]="filtroUsuarioExpandido ? 'open' : 'close'"
            *ngIf="(listaUsuarios?.ativos && listaUsuarios?.ativos.length) || (listaUsuarios?.inativos && listaUsuarios?.inativos.length)">
            <div class="item-filter">
                <div class="all-users">
                    <span class="paragraph-regular">TODOS</span>
                    <mat-checkbox color="primary" [(ngModel)]="checkboxSelected" (change)="selectAll()"></mat-checkbox>
                </div>
            </div>

            <div class="item-filter" *ngIf="listaUsuarios?.ativos.length">
                <span class="paragraph-regular-xs color-sub-title">Ativos</span>
                <div class="lista"
                    [ngClass]="[listaUsuarios?.ativos && listaUsuarios.ativos.length > 8 ? 'overflow-lista' : '' ]">
                    <div class="item" *ngFor="let usuario of listaUsuarios.ativos">
                        <div class="container-nome">
                            <img [src]="usuario.img" onError="this.src='assets/img/usuarioAnonimo.png'">
                            <span>{{usuario.nome}}</span>
                        </div>
                        <mat-checkbox color="primary" (change)="filterUserSelect(usuario)"
                            [(ngModel)]="usuario.selected"></mat-checkbox>
                    </div>
                </div>
            </div>

            <div class="item-filter" *ngIf="listaUsuarios?.inativos.length">
                <span class="paragraph-regular-xs color-sub-title">Inativos</span>
                <div class="lista"
                    [ngClass]="[listaUsuarios?.inativos && listaUsuarios.inativos.length > 8 ? 'overflow-lista' : '' ]">
                    <div class="item" *ngFor="let usuario of listaUsuarios.inativos">
                        <div class="container-nome">
                            <img [src]="usuario.img" onError="this.src='assets/img/usuarioAnonimo.png'">
                            <span>{{usuario.nome}}</span>
                        </div>
                        <mat-checkbox color="primary" (change)="filterUserSelect(usuario)"
                            [(ngModel)]="usuario.selected"></mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <mat-form-field style="margin-top: 20px;" *ngIf="ramosProdutos.length">
        <mat-label>Ramo</mat-label>
        <mat-select panelClass="select-ramo-filter" [(ngModel)]="ramoSelct">
            <mat-option class="option-ramo-filter" [value]="ramo.id" *ngFor="let ramo of ramosProdutos">
                <mat-icon [svgIcon]="ramo.icone"></mat-icon>
                {{ramo.nome}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="actionButtonsFiltros">
        <button mat-button class="btn-limpar-filtro" (click)="clearFilter()">LIMPAR FILTROS</button>
        <button mat-raised-button class="btn-filtro" (click)="buildString()">APLICAR</button>
    </div>
</div>